import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography
} from "@mui/material";
import WestIcon from "@mui/icons-material/West";
import { SlOptionsVertical } from "react-icons/sl";
import { AiOutlineEye } from "react-icons/ai";
import { useNavigate, useParams } from "react-router-dom";
import InputField, {
  Dateinputfield,
  TopInputField,
  TopInputFieldBorderLabel
} from "../../customComponent/InputField";
import { MainContainer } from "../../content/content.element";
import { useDispatch, useSelector } from "react-redux";
import {
  AddEmployeeBonusAction,
  findBonusDetailsAction,
  fetchEnrollmentCountAction
} from "../../../actions/aplicationActions/applicationsAction";
import Swal from "sweetalert2";
import { successTrueMsgAction } from "../../../actions/globalAction";
import { SUCCESS_TRUE_MSG_ERR } from "../../../constants/roleManagmentConstant";
import PremissionDialog from "../../customComponent/premissionDialog";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck";

// const rowData = [
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
//   {
//     from: "2022 Apr 1",
//     to: "2023 Mar 31",
//     enrollmentCount: "200",
//     bonus: "150000",
//   },
// ];

function BonusDetailspage(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [actionButtonShow, setActionButtonShow] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [tableId, setTableId] = useState("");
  const [rowData, setRowData] = useState([]);
  const [profileData, setProfileData] = useState([]);

  // custom Hooks

  const { isCreatePrevilage } = usePrivilegeCheck();

  const [openAlert, setOpenAlert] = useState(false);

  // HandleClose dialog

  const handleCloseDialog = () => {
    setOpenAlert(false);
  };

  let { successAlertMsgSuccess, successAlertMsgErr } = useSelector((state) => {
    return state.successTrueMsg;
  });

  const { addBonusEmployeesSuccess, addBonusEmployeeserror } = useSelector(
    (state) => {
      return state.AddEmployeeBonus;
    }
  );

  const { findBonusEmployeesSuccess } = useSelector((state) => {
    return state.findBonusDetails;
  });

  const {
    fetchEnrollmentCountLoading,
    fetchEnrollmentCountSuccess,
    fetchEnrollmentCountError
  } = useSelector((state) => {
    return state.fetchEnrollmentCount;
  });

  useEffect(() => {
    if (findBonusEmployeesSuccess) {
      setProfileData(findBonusEmployeesSuccess?.data?.profileData);
      setRowData(
        findBonusEmployeesSuccess?.data?.tableData?.map((item) => ({
          from: item?.from,
          to: item?.to,
          enrollmentCount: item?.enrollmentCount,
          bonus: item?.bonusAmount
        }))
      );
    }
  }, [findBonusEmployeesSuccess]);
  const openActionButton = Boolean(actionButtonShow);

  const handleClickAction = (event, id) => {
    setActionButtonShow(event.currentTarget);
    setTableId(id);
  };

  const handleCloseAction = () => {
    setActionButtonShow(null);
  };

  const handleModal = () => {
    if (isCreatePrevilage("bonus")) {
      setOpenModal(!openModal);
    } else {
      setOpenAlert(true);
    }
  };

  // form submit
  const [formData, setFormData] = useState({
    id: id,
    from: "",
    to: "",
    enrollmentCount: "",
    bonus: ""
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (addBonusEmployeesSuccess && successAlertMsgSuccess) {
      Swal.fire("Added!", "Employee Bonus Added Successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
  }, [addBonusEmployeesSuccess]);

  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      enrollmentCount: fetchEnrollmentCountSuccess?.count
    }));
  }, [fetchEnrollmentCountSuccess]);

  useEffect(() => {
    if (addBonusEmployeeserror && successAlertMsgErr) {
      Swal.fire("Added!", addBonusEmployeeserror, "success");
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
    }
  }, [addBonusEmployeeserror]);

  useEffect(() => {
    dispatch(findBonusDetailsAction(id));
  }, [dispatch, addBonusEmployeesSuccess]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => {
      const updatedFormData = { ...prevState, [name]: value };
      if (
        (name === "from" || name === "to") &&
        updatedFormData.from &&
        updatedFormData.to
      ) {
        dispatch(
          fetchEnrollmentCountAction(
            updatedFormData.from,
            updatedFormData.to,
            id,
            profileData?.role?.roleName
          )
        );
      }

      return updatedFormData;
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.from) {
      newErrors.from = "From date is required";
    }
    if (!formData.to) {
      newErrors.to = "To date is required";
    }
    if (!formData.enrollmentCount) {
      newErrors.enrollmentCount = "Enrollment count is required";
    } else if (isNaN(formData.enrollmentCount)) {
      newErrors.enrollmentCount = "Enrollment count must be a number";
    }
    if (!formData.bonus) {
      newErrors.bonus = "Bonus is required";
    } else if (isNaN(formData.bonus)) {
      newErrors.bonus = "Bonus must be a number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Form is valid, handle submission here
      dispatch(AddEmployeeBonusAction(formData));
    } else {
      console.log("Form has errors:", errors);
    }
  };

  return (
    <>
      <MainContainer active={props.toggle}>
        <Box sx={{ background: "#fff" }}>
          <Modal
            open={openModal}
            onClose={handleModal}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              maxWidth: "690px",
              margin: "auto"
            }}
          >
            <DialogContent
              sx={{
                borderRadius: "12px",
                background: "#fff",
                outline: "none"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  "& svg": {
                    cursor: "pointer"
                  }
                }}
              >
                <svg
                  onClick={handleModal}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.00195312"
                    y="1.45312"
                    width="2.05702"
                    height="20.5702"
                    rx="1.02851"
                    transform="rotate(-45 0.00195312 1.45312)"
                    fill="black"
                  />
                  <rect
                    x="14.5449"
                    width="2.05702"
                    height="20.5702"
                    rx="1.02851"
                    transform="rotate(45 14.5449 0)"
                    fill="black"
                  />
                </svg>
              </Box>

              <Box
                sx={{
                  "& input": {
                    outline: "none",
                    width: "100% !important",
                    px: "16px !important",
                    height: "56px !important",
                    mt: "10px",
                    boxSizing: "border-box"
                  },
                  display: "flex",
                  flexDirection: "column",
                  gap: "32px"
                }}
              >
                <form onSubmit={handleSubmit}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "20px"
                    }}
                  >
                    <Box sx={{}}>
                      <Typography>From</Typography>
                      <Dateinputfield
                        handleDateChange={handleChange}
                        dateValue={formData.from}
                        name="from"
                      />
                      {errors.from && (
                        <Typography color="error">{errors.from}</Typography>
                      )}
                    </Box>

                    <Box sx={{}}>
                      <Typography>To</Typography>
                      <Dateinputfield
                        dateValue={formData.to}
                        handleDateChange={handleChange}
                        name="to"
                      />
                      {errors.to && (
                        <Typography color="error">{errors.to}</Typography>
                      )}
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "20px"
                    }}
                  >
                    <Box sx={{}}>
                      <Typography>Enrollment count</Typography>
                      <InputField
                        placeholder={"Enrollment count"}
                        value={formData.enrollmentCount}
                        handleChange={handleChange}
                        name="enrollmentCount"
                      />

                      {errors.enrollmentCount && (
                        <Typography color="error">
                          {errors.enrollmentCount}
                        </Typography>
                      )}
                    </Box>

                    <Box sx={{}}>
                      <Typography>Bonus</Typography>
                      <InputField
                        placeholder={"Bonus"}
                        value={formData.bonus}
                        handleChange={handleChange}
                        name="bonus"
                      />
                      {errors.bonus && (
                        <Typography color="error">{errors.bonus}</Typography>
                      )}
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "end"
                    }}
                  >
                    <Button
                      sx={{
                        background: "rgba(20, 30, 60, 1)",
                        color: "#fff",
                        border: "1px solid rgba(20, 30, 60, 1)",
                        borderRadius: "5px",
                        fontWeight: "600",
                        "&:hover": {
                          color: "rgba(20, 30, 60, 1)"
                        }
                      }}
                      type="submit"
                    >
                      Save
                    </Button>
                  </Box>
                </form>
              </Box>
            </DialogContent>
          </Modal>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              p: "33px",
              backgroundColor: "#ffffff",
              mt: "1px"
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "20px"
              }}
            >
              <WestIcon
                onClick={() => navigate(-1)}
                sx={{ cursor: "pointer" }}
              />
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 700
                }}
              >
                Bonus Details
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              px: "33px"
            }}
          >
            <Box
              sx={{
                border: "1px solid rgba(236, 236, 236, 1)",
                p: "33px",
                display: "flex",
                gap: "20px",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap"
              }}
            >
              <Box
                sx={{
                  borderRadius: "50%",
                  overflow: "hidden",
                  width: "120px",
                  height: "120px",
                  "& img": {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                  }
                }}
              >
                <img
                  src={
                    profileData?.img_url ? profileData?.img_url : "/avatar.png"
                  }
                  alt=""
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "20px",
                    color: "#000",
                    fontWeight: "600"
                  }}
                >
                  {profileData?.firstName}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "18px",
                    color: "rgba(0, 0, 0, 1)"
                  }}
                >
                  {profileData?.role?.roleName}
                </Typography>

                {/* <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  textDecoration: "underline",
                  color: "rgba(20, 30, 60, 1)",
                }}
              >
                Activity log
              </Typography> */}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  justifyContent: "start"
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "16px 1fr",
                    alignItems: "center",
                    gap: "16px"
                  }}
                >
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_8663_66381)">
                      <path
                        d="M3.26133 11.1357C4.83945 13.0222 6.73916 14.5075 8.90742 15.5584C9.73295 15.9496 10.837 16.4138 12.067 16.4934C12.1432 16.4967 12.2162 16.5 12.2924 16.5C13.1179 16.5 13.781 16.2149 14.3214 15.6281C14.3247 15.6247 14.3314 15.6181 14.3347 15.6115C14.527 15.3794 14.7458 15.1705 14.9746 14.9484C15.1304 14.7992 15.2895 14.6434 15.442 14.4843C16.1482 13.7482 16.1482 12.8133 15.4354 12.1005L13.4428 10.108C13.1047 9.75653 12.7002 9.57087 12.2758 9.57087C11.8515 9.57087 11.4437 9.75653 11.0956 10.1046L9.90866 11.2915C9.79925 11.2286 9.68653 11.1722 9.58044 11.1191C9.44782 11.0528 9.32515 10.9898 9.21575 10.9202C8.13493 10.2339 7.15358 9.33879 6.21533 8.18835C5.74123 7.58827 5.42296 7.08433 5.20083 6.57045C5.51247 6.28864 5.80423 5.99358 6.08603 5.70514C6.18549 5.60236 6.28827 5.49959 6.39105 5.39681C6.74911 5.03875 6.9414 4.62433 6.9414 4.20327C6.9414 3.78222 6.75242 3.3678 6.39105 3.00974L5.40307 2.02176C5.28703 1.90572 5.17762 1.793 5.0649 1.67696C4.84608 1.45151 4.61732 1.21944 4.39188 1.01057C4.05039 0.675715 3.64923 0.5 3.22486 0.5C2.80381 0.5 2.39934 0.675715 2.04459 1.01388L0.804641 2.25383C0.35375 2.70472 0.0984656 3.25176 0.0454196 3.885C-0.0175725 4.67737 0.128304 5.51948 0.506257 6.5373C1.08645 8.1121 1.96171 9.57418 3.26133 11.1357ZM0.854371 3.95462C0.894156 3.51368 1.06324 3.14567 1.38152 2.82739L2.61484 1.59407C2.80713 1.40841 3.01931 1.31227 3.22486 1.31227C3.4271 1.31227 3.63266 1.40841 3.82163 1.6007C4.04376 1.80626 4.25263 2.02176 4.47808 2.25052C4.5908 2.36656 4.70684 2.48259 4.82288 2.60195L5.81086 3.58993C6.01641 3.79548 6.1225 4.00435 6.1225 4.2099C6.1225 4.41546 6.01641 4.62433 5.81086 4.82988C5.70808 4.93266 5.6053 5.03875 5.50253 5.14152C5.1942 5.45317 4.90576 5.74824 4.58748 6.03005C4.58085 6.03668 4.57754 6.03999 4.57091 6.04662C4.29573 6.3218 4.33883 6.58371 4.40514 6.78264C4.40845 6.79258 4.41177 6.79921 4.41508 6.80916C4.67037 7.4225 5.02511 8.00601 5.57878 8.70224C6.57339 9.92893 7.62105 10.8804 8.7748 11.6131C8.91736 11.706 9.06987 11.7789 9.21243 11.8518C9.34505 11.9182 9.46771 11.9811 9.57712 12.0508C9.59038 12.0574 9.60033 12.064 9.61359 12.0707C9.723 12.127 9.82909 12.1535 9.93518 12.1535C10.2004 12.1535 10.3728 11.9845 10.4292 11.9281L11.6691 10.6881C11.8614 10.4959 12.0703 10.3931 12.2758 10.3931C12.5278 10.3931 12.7334 10.5489 12.8627 10.6881L14.8618 12.684C15.2597 13.0818 15.2564 13.5128 14.8519 13.9339C14.7126 14.0831 14.5668 14.2257 14.4109 14.3748C14.1789 14.6003 13.9368 14.8324 13.718 15.0943C13.3368 15.5054 12.8826 15.6977 12.2957 15.6977C12.2394 15.6977 12.1797 15.6944 12.1233 15.691C11.0359 15.6214 10.0247 15.1971 9.26548 14.8357C7.20331 13.8378 5.39312 12.4221 3.89125 10.6252C2.65462 9.13655 1.82246 7.75072 1.27211 6.26544C0.930625 5.35371 0.801325 4.62101 0.854371 3.95462Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_8663_66381">
                        <rect
                          width="16"
                          height="16"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>

                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "#000"
                    }}
                  >
                    {profileData?.mobile ? profileData?.mobile : "-"}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "16px 1fr",
                    alignItems: "center",
                    gap: "16px"
                  }}
                >
                  <svg
                    width="16"
                    height="13"
                    viewBox="0 0 16 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.5938 0.875H1.40625C0.632438 0.875 0 1.50466 0 2.28125V10.7188C0 11.4956 0.632844 12.125 1.40625 12.125H14.5938C15.3676 12.125 16 11.4953 16 10.7188V2.28125C16 1.50447 15.3673 0.875 14.5938 0.875ZM14.3778 1.8125C13.9232 2.26866 8.58266 7.62656 8.36325 7.84669C8.18 8.0305 7.82009 8.03062 7.63675 7.84669L1.62219 1.8125H14.3778ZM0.9375 10.5464V2.45359L4.97078 6.5L0.9375 10.5464ZM1.62219 11.1875L5.63263 7.164L6.97278 8.50853C7.52197 9.0595 8.47825 9.05928 9.02725 8.50853L10.3674 7.16403L14.3778 11.1875H1.62219ZM15.0625 10.5464L11.0292 6.5L15.0625 2.45359V10.5464Z"
                      fill="black"
                    />
                  </svg>

                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "#000"
                    }}
                  >
                    {profileData?.email ? profileData?.email : "-"}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "16px 1fr",
                    alignItems: "center",
                    gap: "16px"
                  }}
                >
                  <svg
                    width="12"
                    height="17"
                    viewBox="0 0 12 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 16.0312C4.125 13.2187 0.84375 9.40625 0.84375 6.125C0.84375 3.28184 3.15684 0.968745 6 0.968745C8.84316 0.968745 11.1562 3.28184 11.1562 6.125C11.1562 9.40625 7.875 13.2187 6 16.0312Z"
                      stroke="black"
                      stroke-width="0.9375"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6 8.46875C4.70772 8.46875 3.65625 7.41728 3.65625 6.125C3.65625 4.83272 4.70772 3.78125 6 3.78125C7.29228 3.78125 8.34375 4.83272 8.34375 6.125C8.34375 7.41728 7.29228 8.46875 6 8.46875Z"
                      stroke="black"
                      stroke-width="0.9375"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "#000"
                    }}
                  >
                    {profileData?.country_code
                      ? profileData?.country_code
                      : "-"}
                  </Typography>
                </Box>
              </Box>

              <Button
                sx={{
                  background: "rgba(20, 30, 60, 1)",
                  color: "#fff",
                  border: "1px solid rgba(20, 30, 60, 1)",
                  borderRadius: "5px",
                  fontWeight: "600",
                  "&:hover": {
                    color: "rgba(20, 30, 60, 1)"
                  }
                }}
                onClick={handleModal}
              >
                Add New
              </Button>
            </Box>

            <Box
              sx={{
                maxWidth: "100%",
                overflowX: "scroll",
                mt: "32px"
              }}
            >
              <Table className="landingTable" sx={{ minWidth: "990px" }}>
                <TableHead sx={{ backgroundColor: "#F9F9FB" }}>
                  <TableRow className="landingTableCell">
                    <TableCell
                      sx={{
                        borderBottom: "0",
                        py: "5px"
                      }}
                    >
                      <Checkbox
                        // checked={selectedRows.length === sortedData.length}
                        // onChange={handleSelectAllRows}
                        style={{ color: "#f81b82" }}
                      />
                    </TableCell>
                    {["sl no", "From", "to", "enrollment count", "Bonus"]?.map(
                      (column) => {
                        return (
                          <TableCell
                            key={column.field}
                            className="landingTableCell"
                            sx={{
                              textTransform: "uppercase",
                              color: "#666E7D",
                              fontWeight: "600",
                              borderBottom: "0",
                              py: "5px"
                            }}
                          >
                            <TableSortLabel
                              className="landingHeaderText"
                              // active={column === sortBy}
                              // direction={sortOrder}
                              // onClick={() => requestSort(column)}
                              // IconComponent={
                              //   column.field !== "action" && CustomSortIcon
                              // }
                            >
                              {column}
                            </TableSortLabel>
                          </TableCell>
                        );
                      }
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowData?.map((row, index) => (
                    <TableRow
                      className="landingTable"
                      sx={{
                        "& .MuiTableCell-root ": {
                          borderBottom: "0",
                          py: "5px"
                        }
                      }}
                    >
                      <TableCell>
                        <Checkbox style={{ color: "#f81b82" }} />
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row?.from}</TableCell>
                      <TableCell>{row?.to}</TableCell>
                      <TableCell>{row?.enrollmentCount}</TableCell>
                      <TableCell>{row?.bonus}</TableCell>
                      {/* <TableCell>
                      <SlOptionsVertical
                        id="demo-positioned-button"
                        aria-controls={
                          openActionButton ? "demo-positioned-menu" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={openActionButton ? "true" : undefined}
                        onClick={(e) => {
                          handleClickAction(e, index);
                        }}
                        variant="outlined"
                        style={{ marginLeft: "10px", color: "#F80B7A" }}
                      />

                      <Menu
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={actionButtonShow}
                        open={openActionButton}
                        onClose={handleCloseAction}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                        anchorOrigin={{
                          vertical: "bottom", // Change from "top" to "bottom"
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top", // Change from "top" to "bottom"
                          horizontal: "left",
                        }}
                        sx={{
                          borderColor: "black",
                          borderRadius: "24px",
                          mt: 1.5,
                          width: "auto",
                          height: "auto",
                        }}
                      >
                        <Box
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <MenuItem>
                            <AiOutlineEye
                              onClick={handleModal}
                              className="icons"
                              style={{
                                fontSize: "lg",
                                width: "20px",
                                height: "19px",
                              }}
                            />
                          </MenuItem>
                        </Box>
                      </Menu>
                    </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter />
              </Table>
            </Box>
          </Box>
        </Box>
      </MainContainer>

      {openAlert && (
        <PremissionDialog
          openAlert={openAlert}
          handleClose={handleCloseDialog}
        />
      )}
    </>
  );
}

export default BonusDetailspage;
